import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import OneSignal from 'onesignal-cordova-plugin';
import { Subject } from 'rxjs';
import { environment as env } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { Duelist } from './duelists.service';

type NotificationData =
	| {
			type: 'challenge' | 'closed';
			duel: string;
	  }
	| {
			type: 'accepted';
			duel: string;
			competitor: Duelist;
	  };

// Manually because the LogLevel of the cordova plugin is sometimes undefined
enum LogLevel {
	None,
	Fatal,
	Error,
	Warn,
	Info,
	Debug,
	Verbose,
}

@Injectable({
	providedIn: 'root',
})
export class OneSignalService {
	private appId: string;
	private notification = new Subject<NotificationData>();

	constructor(
		private router: Router,
		authService: AuthenticationService,
	) {
		this.appId = env.oneSignalAppId;

		if (Capacitor.getPlatform() !== 'web') {
			// Change OneSignal external user id based on who is logged in
			authService.authUser$.subscribe({
				next: authUser => {
					if (authUser) {
						OneSignal.login(authUser.userId);
					} else {
						OneSignal.logout();
					}
				},
			});
		}
	}

	public get notification$() {
		return this.notification.asObservable();
	}

	/**
	 * Initializes the oneSignal application if the platform is a mobile device
	 */
	initialize() {
		if (Capacitor.getPlatform() === 'web') return;

		OneSignal.Debug.setLogLevel(LogLevel.Verbose);

		OneSignal.initialize(this.appId);

		OneSignal.Notifications.addEventListener('click', e => {
			const notification = e.notification.additionalData as NotificationData;
			this.router.navigate(['/app', 'duel-detail', notification.duel]);
		});

		OneSignal.Notifications.addEventListener('foregroundWillDisplay', e => {
			const notification = e.getNotification();
			const notificationData = notification.additionalData as NotificationData;
			this.notification.next(notificationData);
		});

		OneSignal.Notifications.requestPermission(true)
			.then((_success: boolean) => {})
			.catch((err: Error) => {
				console.error(err);
			});
	}
}
